<template>

    <!-- desktop -->
     
        <div class="row" style="width: 100vw;">
            <div class="leftmenu left pointer click" style="width: 20vw; padding-left: 2vw;">
                <router-link to="/">
                <svg style="margin-top: 8px;" width="51" height="10" viewBox="0 0 51 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M44.5273 9.57861C43.3678 9.57861 42.3586 9.38395 41.4995 8.99463C40.6405 8.60107 39.974 8.04671 39.5 7.33154C39.0303 6.61637 38.7954 5.77002 38.7954 4.79248V4.77979C38.7954 3.80225 39.0303 2.95589 39.5 2.24072C39.974 1.52555 40.6405 0.973307 41.4995 0.583984C42.3586 0.194661 43.3678 0 44.5273 0C45.6868 0 46.6961 0.194661 47.5552 0.583984C48.4142 0.973307 49.0786 1.52555 49.5483 2.24072C50.0223 2.95589 50.2593 3.80225 50.2593 4.77979V4.79248C50.2593 5.77002 50.0223 6.61637 49.5483 7.33154C49.0786 8.04671 48.4142 8.60107 47.5552 8.99463C46.6961 9.38395 45.6868 9.57861 44.5273 9.57861ZM44.5273 7.67432C45.1833 7.67432 45.7546 7.55794 46.2412 7.3252C46.7321 7.08822 47.1108 6.75391 47.3774 6.32227C47.644 5.88639 47.7773 5.37646 47.7773 4.79248V4.77979C47.7773 4.19157 47.644 3.68376 47.3774 3.25635C47.1108 2.82471 46.7321 2.4904 46.2412 2.25342C45.7546 2.01644 45.1833 1.89795 44.5273 1.89795C43.8672 1.89795 43.2938 2.01644 42.8071 2.25342C42.3205 2.4904 41.9438 2.82471 41.6772 3.25635C41.4106 3.68376 41.2773 4.19157 41.2773 4.77979V4.79248C41.2773 5.37646 41.4106 5.88639 41.6772 6.32227C41.9438 6.75391 42.3205 7.08822 42.8071 7.3252C43.2938 7.55794 43.8672 7.67432 44.5273 7.67432Z" fill="white"/><path d="M23.9932 9.36865V0.208984H26.8687L30.125 6.78516H30.1948L33.4448 0.208984H36.3203V9.36865H34.0986V3.25586H33.1592L34.8413 1.43408L30.9756 9.36865H29.3315L25.4722 1.43408L27.1543 3.25586H26.2148V9.36865H23.9932Z" fill="white"/><path d="M12.8599 9.36865V0.208984H21.2896V1.99902H15.291V3.92236H20.877V5.54736H15.291V7.57861H21.2896V9.36865H12.8599Z" fill="white"/><path d="M0 9.36865V0.208984H5.12256C6.25244 0.208984 7.20671 0.384603 7.98535 0.73584C8.76823 1.08708 9.36279 1.60124 9.76904 2.27832C10.1753 2.95117 10.3784 3.7679 10.3784 4.72852V4.74121C10.3784 5.73568 10.1753 6.5778 9.76904 7.26758C9.36279 7.95736 8.76823 8.47998 7.98535 8.83545C7.20671 9.19092 6.25244 9.36865 5.12256 9.36865H0ZM2.43115 7.52148H4.93213C5.56266 7.52148 6.09798 7.41992 6.53809 7.2168C6.98242 7.01367 7.31885 6.70898 7.54736 6.30273C7.78011 5.89648 7.89648 5.3929 7.89648 4.79199V4.7793C7.89648 4.19108 7.78434 3.69596 7.56006 3.29395C7.34001 2.8877 7.00781 2.58089 6.56348 2.37354C6.12337 2.16195 5.57959 2.05615 4.93213 2.05615H2.43115V7.52148Z" fill="white"/></svg>
                </router-link>
            </div>
            <div class="centermenu center row wrap ch" style="width: 60vw">
                <!-- <a class="menuitem pointer click" :href="item.link" v-for="(item, index) in demo.activemenu" :key="index">{{ item.name }}<sup style="color: var(--bad);" v-if="item.new">new</sup> </a>             -->
                
                
                    <router-link v-for="(item, index) in demo.menu" :key="index" class="menuitem pointer click" :to="{name: item.id}" >{{ item.title }}</router-link>   
                
                    <router-link v-if="db.god" class="menuitem" :to="{name:'admin'}">Admin</router-link>

                <!-- <Menu scroll>                    
                    <template #title><p class="menuitem pointer click">more...</p> </template>                                        
                        <div class="column left" style="padding: 10px 10px;">
                            <a class="menuitem pointer click" :href="item.link" v-for="(item, index) in demo.moremenu" :key="index">{{ item.name }}<sup style="color: var(--bad);" v-if="item.new">new</sup> </a>            
                        </div>
                </Menu> -->
                
                <!-- <Menu scroll>                    
                    <template #title><p class="menuitem pointer click" title="Menu settings">፨</p> </template>                                        
                        <div class="column left" style="padding: 10px 10px;">
                            <a class="menuitem pointer click" :href="item.link" v-for="(item, index) in demo.menu" :key="index">{{ item.name }}<sup style="color: var(--bad);" v-if="item.new">new</sup> </a>            
                        </div>                                                                    
                </Menu> -->

                <!-- <div class="pointer click">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.40002 7H4.40587M7.00327 7H7.00847M9.59417 7H9.60002" stroke="white" stroke-opacity="0.2" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M7 13.5C10.5899 13.5 13.5 10.5899 13.5 7C13.5 3.41015 10.5899 0.5 7 0.5C3.41015 0.5 0.5 3.41015 0.5 7C0.5 10.5899 3.41015 13.5 7 13.5Z" stroke="white" stroke-opacity="0.2"/></svg>
                </div> -->

                
            </div>

            <div class="rightmenu right" style="width:20vw; padding-right: 2vw;">
                <router-link class="menuitem" :to="{name:'profile'}">profile</router-link>
                
                <!-- <a class="menuitem" href="/profile"></a> -->
                <!-- <a v-if="db.god" class="menuitem" href="/admin">god</a> -->
            </div>
        </div>


    
</template>


<script>
export default {
    data: function () {return {               
                // 
    }},
    mounted() {
        // 
    },
    methods: {
    //   

    },
    computed: {
       activelist(){
            return ''
       },
    },   
}
</script>


<style scoped>
.container{
    display: flex;
    flex-direction: column;
    position: fixed;
    align-items: center;
    justify-content: center;
    top: 0;
    /* height: 30px; */
    width: 100vw;
    /* padding: 6px; */
    background-color: var(--back);
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    backdrop-filter: saturate(180%) blur(20px);
    z-index: 10000000;

}

.blur {
  background: #1c1c1cd0;
  backdrop-filter: blur(50px);
  /* backdrop-filter: blur(50px) saturate(200%); */
  -webkit-backdrop-filter: blur(50px);
  /* -webkit-backdrop-filter: blur(50px) saturate(200%); */
  /* border: 1px solid rgba(255, 255, 255, 0.1); */
}
.logos{
    position: fixed;
    left: 60px;
    top: 40px;
    z-index:1000;
  }
</style>

